export enum NewsVisibility {

    Open = 0,
    Internal = 1,
    Closed = 2

}
